import { Component, DestroyRef } from '@angular/core';
import { AiAgentConfigurationComponent } from '../../components/ai-assistant-components/ai-agent-configuration/ai-agent-configuration.component';
import { AiAgentConfigurationGetStartedComponent } from '../../components/ai-assistant-components/ai-agent-configuration-get-started/ai-agent-configuration-get-started.component';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { AssistantsListComponent } from '../../components/ai-assistant-components/assistants-list/assistants-list.component';
import { IntegrationsComponent } from '../../components/ai-assistant-components/integration-components/integrations/integrations.component';
import { TransferComponent } from '../../components/ai-assistant-components/transfer/transfer.component';
import { AiConfigurationPageEventsService } from '../../events/ai-configuration-page-events.service';
import { AiAgentResponse } from '../../models/responses/ai-agent-response';
import { SubscriptionHelper } from '../../classes/subscription-helper';
import { ActivatedRoute, Router } from '@angular/router';
import { variablePathNames } from '../../utilities/routing-path-utils';
import { AiAgentService } from '../../services/ai-agent.service';
import { KnowledgeBaseComponent } from '../../components/ai-assistant-components/knowledge-base/knowledge-base.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DiagramFlowComponent } from '../../components/ai-assistant-components/diagram-flow-actions-components/diagram-flow/diagram-flow.component';
import { TestAssistantComponent } from '../../components/ai-assistant-components/ai-aigent-component/test-assistant/test-assistant.component';
import { CallLogTabComponent } from '../../components/ai-assistant-components/call-log-tab/call-log-tab.component';
import { AiAgentDashboardComponent } from '../../components/ai-assistant-components/ai-agent-dashboard/ai-agent-dashboard.component';
import { UpdateAiAgentRequest } from '../../models/requests/update-ai-agent-request';
import { VoiceProvider } from '../../models/enums/voice-provider';
import { AgentType } from '../../models/enums/agent-type';
import { OutboudCampaignsComponent } from '../../components/outbound-campaigns/outbound-campaigns.component';
import { MatDialog } from '@angular/material/dialog';
import { GhlIntegrationDialogComponent } from '../../components/ai-assistant-components/integration-components/ghl-integration-dialog/ghl-integration-dialog.component';
import { MissedOutboundCallsComponent } from '../../components/ai-assistant-components/missed-outbound-calls/missed-outbound-calls.component';
import { GoogleSheetDialogComponent } from '../../components/ai-assistant-components/integration-components/google-sheet-dialog/google-sheet-dialog.component';

@Component({
  selector: 'app-ai-agent-configuration-page',
  standalone: true,
  imports: [
    AiAgentConfigurationComponent,
    AiAgentConfigurationGetStartedComponent,
    AssistantsListComponent,
    CallLogTabComponent,
    IntegrationsComponent,
    OutboudCampaignsComponent,
    MissedOutboundCallsComponent,
    NgIf,
    MatButtonModule,
    MatTabsModule,
    NgSwitchCase,
    NgSwitch,
    MatButtonModule,
    MatIconModule,
    TransferComponent,
    KnowledgeBaseComponent,
    MatProgressSpinnerModule,
    DiagramFlowComponent,
    TestAssistantComponent,
    AiAgentDashboardComponent
  ],
  templateUrl: './ai-agent-configuration-page.component.html',
  styleUrl: './ai-agent-configuration-page.component.scss'
})
export class AiAgentConfigurationPageComponent {
  elementsToRender: string[] = ['assistants-list', 'get-started', 'config'];
  shouldRenderGetStarted: boolean = true;
  elementToRender: string = this.elementsToRender[0];
  selectedIndex: number = 0;
  subscriptions: SubscriptionHelper;
  aiAgent!: AiAgentResponse;
  oauth2Callback!: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private destroyRef: DestroyRef,
    public dialog: MatDialog,
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService,
    private aiAgentService: AiAgentService
  ) {
    this.subscriptions = new SubscriptionHelper(destroyRef);
  }

  ngOnInit() {
    this.initSubscriptions();
    this.validatePageAccess();
    // this.setCallbackUrlParam()
  }

  validatePageAccess() {
    if (this.elementToRender == this.elementsToRender[0]) {
      const aiAgentId: string = this.getAiAgentId();
      const selectedIndex: string = this.getSelectedIndex();

      if (aiAgentId != '' && selectedIndex != '') {
        this.elementToRender = this.elementsToRender[2];
        this.selectedIndex = parseInt(selectedIndex);

        if (!this.aiAgent)
          this.fetchAiAgentById(parseInt(aiAgentId));
      }
    }
  }

  private fetchAiAgentById(aiAgentId: number) {
    this.aiAgentService.fetchAiAgentById(aiAgentId).subscribe(agent => {
      this.aiAgent = agent;
      this.setCallbackUrlParam()
      this.updatePath();
    });
  }

  //SUBSCRIPTIONS

  initSubscriptions() {
    this.subscribeToOnCreateNewAssistantEvent();
    this.subscribeToOnEditAssistantEvent();
    this.subscribeToOnRefreshAiAgentEvent();
    this.subscribeToOnTabToRenderEvent();
  }

  subscribeToOnTabToRenderEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onTabToRenderEvent.subscribe(index => {
        this.selectedIndex = index;
      }));
  }

  subscribeToOnRefreshAiAgentEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onRefreshAiAgentEvent.subscribe(() => {
        this.fetchAiAgentById(this.aiAgent.id);
      }));
  }

  subscribeToOnCreateNewAssistantEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onCreateNewAssistantEvent.subscribe(aiAgent => {
        this.aiAgent = aiAgent;
        this.elementToRender = this.elementsToRender[1];
        this.updatePath();
      }));
  }

  subscribeToOnEditAssistantEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onEditAssistantEvent.subscribe(aiAgent => {
        this.elementToRender = this.elementsToRender[2];
        this.selectedIndex = 0;
        this.aiAgent = aiAgent;
        this.updatePath();
      }));
  }
  setCallbackUrlParam() {
    const oauth2Callback = this.getOauthCallBack();
    const agentId = parseInt(this.getAiAgentId());
    var integrationId = parseInt(this.getOauthCallBackIntegrationId());
    var component: any = undefined;
    if (oauth2Callback == 'ghl') {
      component = GhlIntegrationDialogComponent;
    }else if(oauth2Callback == 'google-sheet'){

      alert(this.aiAgent)
      integrationId = this.aiAgent.integrations.id
      component = GoogleSheetDialogComponent
    }

    this.conditionalyOpenIntegrationComponent(component, integrationId, agentId);
  }
  
  stopRenderingGetStarted() {
    this.shouldRenderGetStarted = false;
  }

  onAgentTypeSelectedEvent(isInbound: boolean) {
    const updateAiAgentRequest: UpdateAiAgentRequest = {
      agentContext: this.aiAgent.agentContext,
      agentLanguages: this.aiAgent.agentLanguages,
      chosenVoiceId: this.aiAgent.voiceSettings.chosenVoiceId,
      chosenVoiceName: this.aiAgent.voiceSettings.chosenVoiceName,
      voiceSpeed: this.aiAgent.voiceSettings.speed,
      voiceSimilarity: this.aiAgent.voiceSettings.similiarity,
      voiceStability: this.aiAgent.voiceSettings.stability,
      isNonInterruptibleMessage:this.aiAgent.isNonInterruptibleMessage,
      greeting: this.aiAgent.greeting,
      latencySettings:this.aiAgent.latencySettings,
      id: this.aiAgent.id,
      name: this.aiAgent.name,
      agentType: isInbound ? AgentType.INBOUND : AgentType.OUTBOUND,
      sample: "",
      voiceProvider: VoiceProvider.AURA
    };

    this.aiAgentService.updateAiAgent(updateAiAgentRequest).subscribe({
      next: (data) => {
        this.aiAgent = data;
        this.elementToRender = this.elementsToRender[2];
      },
      error: () => {
        alert('Error from server, contact support')
      }
    })

  }

  onSelectedTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
    this.updatePath();
  }

  onBackClick() {
    this.elementToRender = this.elementsToRender[0];
    this.selectedIndex = 0;

    this.router.navigate([], {
      queryParams: {},
    });
  }

  // PRIVATE

  private updatePath() {
    this.router.navigate([], {
      queryParams: { aiAgentId: this.aiAgent.id, selectedIndex: this.selectedIndex },
      queryParamsHandling: 'merge'
    });
  }
  
  private conditionalyOpenIntegrationComponent(component: any, integrationId: number, agentId: number) {
    if (component) {
      this.dialog.open(component, {
        width: '50%',
        autoFocus: false,
        data: { integrationId: integrationId, agentId: agentId }
      });
    }
  }

  private getAiAgentId(): string {
    return this.route.snapshot.queryParamMap.get(variablePathNames.aiAgentIdConfigPathVariable) || '';
  }
  private getSelectedIndex(): string {
    return this.route.snapshot.queryParamMap.get(variablePathNames.aiSelectIndexConfigPathVariable) || '';
  }
  private getOauthCallBack(): string {
    return this.route.snapshot.queryParamMap.get(variablePathNames.oauthCallBackPathVariable) || '';
  }
  private getOauthCallBackIntegrationId(): string {
    return this.route.snapshot.queryParamMap.get(variablePathNames.oauthCallBackIntegrationIdPathVariable) || '';
  }
}
